import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { IconOption, IconKind } from '../../../job-order-type-standalone/job-order-type.model';

@Component({
    selector: 'app-live-form-preview',
    templateUrl: './live-form-preview.component.html',
    styleUrls: ['./live-form-preview.component.scss'],
    standalone: false
})
export class LiveFormPreviewComponent implements OnInit {
  translate: any;
  data: any;
  addJobOrderPreviewForm: FormGroup;
  jobOrderType: any;
  statuses: any = [];
  minDateForEndDate: Date;
  minDate: Date;
  durationOpts: any = [];
  showAsset: boolean = false;
  showCustomer: boolean = false;
  sections: any = [];

  customers: any = [];
  selectedIcon: IconOption | null = null;
  iconOptions: IconOption[] = [
    { key: '#010', kind: 'fa', faClass: 'fa-regular fa-screwdriver-wrench', bgClass: 'icon-bg-010', iconCode: 'fa-screwdriver-wrench' },
    { key: '#143', kind: 'fa', faClass: 'fa-regular fa-calendar-check',    bgClass: 'icon-bg-143', iconCode: 'fa-calendar-check' },
    { key: '#135', kind: 'fa', faClass: 'fa-regular fa-wrench',            bgClass: 'icon-bg-135', iconCode: 'fa-wrench' },
    { key: '#132', kind: 'fa', faClass: 'fa-regular fa-magnifying-glass-waveform', bgClass: 'icon-bg-132', iconCode: 'fa-magnifying-glass-waveform' },
    { key: '#102', kind: 'fa', faClass: 'fa-regular fa-truck',  bgClass: 'icon-bg-102', iconCode: 'fa-truck'},
    { key: '#142', kind: 'fa', faClass: 'fa-regular fa-arrow-rotate-left',  bgClass: 'icon-bg-142', iconCode: 'fa-arrow-rotate-left' },
    { key: '#144', kind: 'fa', faClass: 'fa-regular fa-warehouse',  bgClass: 'icon-bg-144', iconCode: 'fa-warehouse' },
    { key: '#145', kind: 'fa', faClass: 'fa-regular fa-bolt', bgClass: 'icon-bg-145', iconCode: 'fa-bolt' },
    { key: '#146', kind: 'fa', faClass: 'fa-regular fa-gauge-high', bgClass: 'icon-bg-146', iconCode: 'fa-gauge-high' },
    { key: '#123', kind: 'fa', faClass: 'fa-regular fa-arrow-up', bgClass: 'icon-bg-123', iconCode: 'fa-arrow-up' },
    { key: '#147', kind: 'fa', faClass: 'fa-solid fa-map-location-dot', bgClass: 'icon-bg-147', iconCode: 'fa-map-location-dot' },
    { key: '#004', kind: 'fa', faClass: 'fa-regular fa-clipboard-check', bgClass: 'icon-bg-004', iconCode: 'fa-clipboard-check' },
    { key: '#148', kind: 'fa', faClass: 'fa-regular fa-triangle-exclamation', bgClass: 'icon-bg-148', iconCode: 'fa-triangle-exclamation'},
    { key: '#080', kind: 'fa', faClass: 'fa-regular fa-shield-halved', bgClass: 'icon-bg-080', iconCode: 'fa-shield-halved' },
    { key: '#149', kind: 'fa', faClass: 'fa-regular fa-person', bgClass: 'icon-bg-149',iconCode: 'fa-person' },
  ];

  constructor(
     public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService
  ) { 
    this.addJobOrderPreviewForm = new FormGroup({
      jobOrderName: new FormControl(''),
      status: new FormControl(''),
      installationDate: new FormControl(''),
      endDateTime: new FormControl(''),
      completionDate: new FormControl('')
    })
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.selectedIcon = this.iconOptions[0];
  }
 //Language
  getLanguageData() {
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data
        }
      })
  }

  onCancelClick(){
    this.modalRef.hide();
  }
}